import { render, staticRenderFns } from "./nodeWrapper.vue?vue&type=template&id=4baeb039&scoped=true"
import script from "./nodeWrapper.vue?vue&type=script&lang=js"
export * from "./nodeWrapper.vue?vue&type=script&lang=js"
import style0 from "./nodeWrapper.vue?vue&type=style&index=0&id=4baeb039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baeb039",
  null
  
)

export default component.exports